import { setUserRole, USER_ROLES, testUserRole } from "./utils/userRoles";
import { auth } from "./firebase";

// Run this function once to set yourself as admin
// You can call this from the browser console after logging in
export const setupInitialAdmin = async (userId = null) => {
  // If no userId provided, use current user
  const targetUserId = userId || auth.currentUser?.uid;
  
  if (!targetUserId) {
    console.log("❌ No user ID provided and no user logged in");
    return;
  }
  
  console.log("Setting up initial admin for user:", targetUserId);
  const success = await setUserRole(targetUserId, USER_ROLES.ADMIN);
  
  if (success) {
    console.log("✅ Admin role set successfully!");
    console.log("You can now access /admin route");
    
    // Test the role immediately
    console.log("Testing role...");
    await testUserRole(targetUserId);
  } else {
    console.log("❌ Failed to set admin role");
  }
};

// Quick function to set current user as admin
export const makeCurrentUserAdmin = async () => {
  if (!auth.currentUser) {
    console.log("❌ No user is currently logged in");
    return;
  }
  
  console.log("Making current user admin:", auth.currentUser.uid);
  await setupInitialAdmin(auth.currentUser.uid);
};

// Quick function to set current user as moderator
export const makeCurrentUserModerator = async () => {
  if (!auth.currentUser) {
    console.log("❌ No user is currently logged in");
    return;
  }
  
  console.log("Making current user moderator:", auth.currentUser.uid);
  const success = await setUserRole(auth.currentUser.uid, USER_ROLES.MODERATOR);
  
  if (success) {
    console.log("✅ Moderator role set successfully!");
    console.log("You can now access moderator routes");
    
    // Test the role immediately
    console.log("Testing role...");
    await testUserRole(auth.currentUser.uid);
  } else {
    console.log("❌ Failed to set moderator role");
  }
};

// Make functions available globally for console use
window.setupInitialAdmin = setupInitialAdmin;
window.makeCurrentUserAdmin = makeCurrentUserAdmin;
window.makeCurrentUserModerator = makeCurrentUserModerator;
window.testUserRole = testUserRole;
window.setUserRole = setUserRole;
